const TVIcon = ({className, pathClassName})=>
<svg className={className}
     viewBox="0 0 458 281">
  <path d="M457.5.1v280.2H.7V0h456.8Z" className="fill-island"/><path class={pathClassName} d="m57 14.8 7 5.8-38.3 46.9-7.1-5.9 38.3-46.8Zm30.2 1.5 7 5.8-63.6 77.6-7-5.8 63.6-77.6Zm31.3-3.2 7.2 5.9-97.9 119.3-7-5.9 97.7-119.3Z"/>
</svg>

export default TVIcon